export const en = {
  common: {
    'part-labels': {
      one: 'Part I.',
      two: 'Part II.',
      three: 'Part III.'
    },
    cgFirstName: 'CG First Name',
    cgLastName: 'CG Last Name',
    relation: 'Relation',
    riskLevel: 'Risk Level',
    startDate: 'Start Date',
    indicate: 'Indicate',
    interventionSchedule: 'Intervention Schedule',
    noBereavements: 'No bereavements were found for this patient.',
    other: 'Other',
    yes: 'Yes',
    submit: 'Submit',
    close: 'Close',
    no: 'No',
    kps: 'KPS',
    pps: 'PPS',
    na: 'N/A',
    loading: 'Loading',
    blank: ' ',
    nav: {
      chart: 'Chart',
      close: 'Close',
      logout: 'Logout',
      print: 'Print',
      facesheet: 'Facesheet'
    },
    patientId: 'Patient ID',
    dcCPP: "DC'd on",
    coveredNo: 'N',
    coveredYes: 'Y',
    on: {
      id: 'on',
      defaultMessage: 'on'
    },
    standingOrderInEffect: {
      id: 'standingOrderInEffect',
      defaultMessage: 'Standing Order in Effect from'
    },
    physician: {
      id: 'physician',
      defaultMessage: 'Physician'
    },
    createdBy: {
      id: 'createdBy',
      defaultMessage: 'Created by'
    },
    has: {
      id: 'has',
      defaultMessage: 'has'
    },
    have: {
      id: 'have',
      defaultMessage: 'have'
    },
    prnPerm: {
      id: 'prnPerm',
      defaultMessage: 'permission to make PRN visits without prior approval.'
    }
  },
  errorForm: 'Error loading the form',

  /* Override AG-Grid default translations below */
  // grid: {}
  // HOPE
  SIAStatement: ', how has the patient been affected by each of the following symptoms? Base this on your clinical assessment (including input from patient and/or caregiver). Symptoms may impact multiple patient activities including, but not limited to, sleep, concentration, day to day activities, or ability to interact with others.',
  MilestonePeriod: 'Over the past 2 days',
  SFVPeriod: 'Since the last symptom impact assessment',
  pain: 'Pain',
  shortnessOfBreath: 'Shortness of breath',
  anxiety: 'Anxiety',
  nausea: 'Nausea',
  vomiting: 'Vomiting',
  diarrhea: 'Diarrhea',
  constipation: 'Constipation',
  agitation: 'Agitation',
  HopeCodes: {
    none: 'None. The symptom did not affect the patient.',
    mild: 'Mild. The symptom affected the patient only a little.',
    moderate: 'Moderate. The symptom affected the patient somewhat. This will likely have a noticeable impact on daily activities.',
    severe: 'Severe. The symptom affected the patient a great deal. This typically indicates a significant limitation in daily function.',
    notApplicable: 'Not applicable (the patient is not experiencing the symptom)'
  },
  HopeMilestones: {
    AdmitMilestone: 'HOPE Admit',
    HUVMilestone: 'HOPE update visit',
    SFVMilestone: 'HOPE Symptom followup'
  },
  HopeOptions: {
    CompleteINA: 'Complete INA',
    CompleteSIA: 'Complete SIA',
    Unapprove: 'Un-approve',
    RecordSFV: 'Record SFV',
    Approve: 'Approve',
    CompleteNVR: 'Complete NVR',
    NoSFV: 'Record missed SFV',
    CompleteHUV1: 'Complete HUV1',
    CompleteHUV2: 'Complete HUV2',
    Download: 'Download',
    Accept: 'Accept',
    Reject: 'Reject',
    RemoveAcceptance: 'Remove Acceptance',
    Discard: 'Discard'
  },
  HopeNoSFVReasons: {
    declined: 'Patient and/or caregiver declined an in-person visit.',
    unavailable: 'Patient unavailable (e.g., in ED, hospital, travel outside of service area, expired).',
    cantContact: 'Attempts to contact patient and/or caregiver were unsuccessful.',
    noneOfTheAbove: 'None of the above.'
  },
  HopeDocumentErrors: {
    noError: 'No Error',
    warning: 'Warning',
    error: 'Error'
  }
};
export default en;